import React from 'react';

export const YouTube = ({ title, id }) => (
    <div className="video-wrapper">
        <iframe
            src={`https://www.youtube-nocookie.com/embed/${id}?rel=0`}
            title={title || 'YouTube video'}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
        />
    </div>
);
